import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function WACloudNumbers() {
  const [loading, setLoading] = useState(true);
  const [numbers, setNumbers] = useState([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const r = await api.waCloud.listNumbers();
        if (mounted) setNumbers(r?.items || []);
      } catch (e) {
        if (mounted) setMsg(`Error: ${e.message}`);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const probarWebhook = async () => {
    try {
      setMsg('');
      const r = await api.waCloud.testWebhook();
      setMsg(r?.ok ? 'Webhook OK (mock)' : 'No se pudo probar');
    } catch (e) {
      setMsg(`Error: ${e.message}`);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>WA Cloud: Números & Webhooks</h2>
      <div style={{ marginBottom: 12 }}>
        <a href="/connect/whatsapp-cloud">← Volver al Wizard</a>
      </div>

      {loading && <div>Cargando…</div>}

      {!loading && numbers.length === 0 && (
        <div style={{ border: '1px dashed #ccc', padding: 16, borderRadius: 8 }}>
          <strong>Sin números aún.</strong>
          <div style={{ marginTop: 8 }}>
            <button onClick={probarWebhook}>Probar webhook (mock)</button>
          </div>
        </div>
      )}

      {!loading && numbers.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee', padding: 8 }}>Número</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee', padding: 8 }}>ID</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee', padding: 8 }}>Estado Webhook</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #eee', padding: 8 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {numbers.map((n) => (
                <tr key={n.id}>
                  <td style={{ padding: 8 }}>{n.display_phone_number || n.phone}</td>
                  <td style={{ padding: 8 }}>{n.id}</td>
                  <td style={{ padding: 8 }}>{n.webhook_ok ? 'OK' : '—'}</td>
                  <td style={{ padding: 8 }}>
                    <button onClick={probarWebhook}>Probar webhook (mock)</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {msg && <div style={{ marginTop: 12, padding: 8, border: '1px solid #eee' }}>{msg}</div>}
    </div>
  );
}